import { makeStyles } from "@material-ui/styles";
import { styled } from "@mui/material/styles";
import { Autocomplete } from "@mui/material";
import { APP_COLOR,APP_HOVER_COLOR, FONT_FAMILY } from "../../theme";

export const useStyles = makeStyles({
  customTextField: {
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
});

export const submitButtonStyle = {
  width: "80%",
  textTransform: "none",
  color: "black",
  backgroundColor: APP_COLOR,
  borderColor: APP_COLOR,
  "&:hover": {
    borderColor: APP_COLOR,
    backgroundColor: APP_HOVER_COLOR,
  },
  fontFamily: FONT_FAMILY,
  height: 40,
  "&.Mui-disabled": {
    color: "B1D1F2",
    backgroundColor: APP_HOVER_COLOR,
  },
};

export const setupProfileStyles = {
  panelButtonsDeactive: {
    color: "white",
    textTransform: "none",
  } as const,
  panelButtonsActive: { color: "#27B6CB", textTransform: "none" } as const,
};
export const SelectField = styled(Autocomplete)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#a6cfd5",
      borderWidth: 2,
      height: "100%",
    },
    "&:hover fieldset": {
      borderColor: "#a6cfd5",
    },
    "&.Mui-focused fieldset": {
      borderColor: APP_COLOR,
    },
  },
});
